import Vue from 'vue';
import { EvaluationStatus } from '@/pipeline/stateMachine';

export const DEAL_STAGE_APPROVED_HUBSPOT_ID = 1475454;
export const DEAL_STAGE_DISAPPROVED_HUBSPOT_ID = 1681730;

export const dealStageIdMapping: Record<string, number> = {
  success: DEAL_STAGE_APPROVED_HUBSPOT_ID,
  retryEssay: DEAL_STAGE_DISAPPROVED_HUBSPOT_ID,
  failure: DEAL_STAGE_DISAPPROVED_HUBSPOT_ID,
};

export const applicationStatusMapping: Record<string, string> = {
  success: 'approved',
  pendingApproval: 'ready for evaluation',
  retryEssay: 'disapproved',
  failure: 'disapproved',
};

const EMAIL_ALIAS = 'used_mixpanel_email_alias';

// DEPRECATED
class Analytics {
  static identify({ id, email, name }: { id: string; email?: string; name?: string }) {
    if (window.POCKET) {
      const accountsUser = window.POCKET.profile();
      const isSameAccountsUser = id === accountsUser?.email;

      if (isSameAccountsUser && accountsUser) {
        window.POCKET.alias(accountsUser.id.toString());
      }
      if ((isSameAccountsUser || !accountsUser) && !Vue.$cookies.get(EMAIL_ALIAS)) {
        window.POCKET.alias(id);
        Vue.$cookies.set(EMAIL_ALIAS, true, '1m', '/', '.descomplica.com.br');
      }
      window.POCKET.identify(id, { email, name, $email: email });
    }
  }

  static track(eventName: string, props: Object = {}): void {
    if (window.POCKET)
      window.POCKET.track(eventName, {
        business_category: 'faculdade',
        category: 'faculdade',
        useMixpanel: true,
        useHubspot: true,
        ...props,
      });
  }

  static getRawUrl(): string {
    const { host, pathname } = window.location;
    return `${host}${pathname}`;
  }

  static trackGTM(props: Object) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(props);
  }

  static trackPageView() {
    Analytics.trackMixpanel('Page View', { gt_Location: this.getRawUrl() });
  }

  static trackHubSpot(eventName: string, props: Object = {}) {
    Analytics.track(eventName, {
      useMixpanel: false,
      ...props,
    });
  }

  static trackMixpanel(eventName: string, props: Object = {}) {
    Analytics.track(eventName, {
      useHubspot: false,
      ...props,
    });
  }

  static trackApplicationStatus(
    evaluationStatus: EvaluationStatus,
    email: string,
    admissionId: number,
  ) {
    const status = evaluationStatus || '';

    Analytics.track('User Application Status', {
      processoSeletivoId: admissionId,
      email,
      applicationStatus: applicationStatusMapping[status],
      lead_status: applicationStatusMapping[status],
      deal_stage: dealStageIdMapping[status],
    });
  }

  static trackEssayEvaluationSent(
    uploadType: string,
    fileMimeType: string = '',
    email: string,
    admissionId: number,
  ) {
    let evaluationTypeSent;
    if (uploadType === 'text') evaluationTypeSent = 'Redação digitada';
    else if (uploadType === 'file') {
      if (fileMimeType.includes('image/')) evaluationTypeSent = 'Redação foto';
      else evaluationTypeSent = 'Redação arquivo';
    }

    Analytics.track('Evaluation Sent', {
      processoSeletivoId: admissionId,
      email,
      evaluationTypeSent,
      grad_processo_seletivo: 'Redação',
    });
  }

  static trackFirstAccess() {
    Analytics.trackGTM({ event: 'first_access' });
  }
}

export default Analytics;
